export default {
    headers: {
        fillHealthInformation: {
            id: 'mobile.headers.fillHealthInformation'
        }
    },
    intros: {
        fillHealthInformation: {
            id: 'mobile.intros.fillHealthInformation'
        }
    }
};
